import { render, staticRenderFns } from "./Running.vue?vue&type=template&id=4bb64618"
import script from "./Running.vue?vue&type=script&lang=js"
export * from "./Running.vue?vue&type=script&lang=js"
import style0 from "./Running.vue?vue&type=style&index=0&id=4bb64618&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports